import React, { useContext, useEffect, useRef, useState } from 'react';
import { MdSwapHoriz } from "react-icons/md";
import layerIcon from '../assets/layericon.png';


import {
  GoogleMap,
  Marker,
  Autocomplete,
  DirectionsRenderer,
  useJsApiLoader,
} from '@react-google-maps/api';
import { MdSwapVert } from "react-icons/md";
import { FaLocationArrow } from 'react-icons/fa';
import { FaDeleteLeft, FaArrowTurnDown } from "react-icons/fa6";
import { useNavigate, useParams } from 'react-router-dom';
import './styles/Map.css';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { UserContext } from '../UserContext'; // Importing UserContext to get user information
import Tabs from '../components/Tabs/Tabs';
import { notifyError, notifySuccess, ToastContainer } from '../components/ErrorAlert'; // Import react-toastify for notifications
import { NotifyMessages } from '../components/NotifyMessages'; // Adjust the path as needed
import moment from 'moment'; // Importing moment.js for date manipulation
import getTrainRoutes from '../components/getTrainRoutes';
import getFlightRoutes from '../components/getFlightRoutes';
import { searchStation } from '../components/searchStation';
import { searchAirport } from '../components/searchAirport';
import _ from "lodash";
import { GOOGLE_LIBRARIES } from "../googleLibraries";
const center = { lat: 21.0000, lng: 78.0000 }; // Default center for the Google Map
const libraries = ['places']; // Define libraries outside the component
//Formatting the dates
const formatDate = (dateString) => {
  const date = new Date(dateString);
  return `${date.toLocaleDateString('sv-SE')}T${date.toLocaleTimeString('en-GB', { hour12: false }).slice(0, 5)}`;
};

function Map() {
  const navigate=useNavigate();
  const { user, token } = useContext(UserContext); // Accessing user information and authentication token from context
  const { requestId } = useParams(); // Fetching request ID from the URL params
 const { isLoaded } = useJsApiLoader({
  googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
  libraries: ["places"],
  region: "IN",
  language: "en",

});

//statses related to map design

const [showMapOptions, setShowMapOptions] = useState(false);
const [mapType, setMapType] = useState("roadmap");
const [mapDetails, setMapDetails] = useState({
  traffic: false,
  transit: false,
  bicycling: false,
});
  // States related to travel route
  const [mapLoading, setMapLoading] =useState(false);
  const [map, setMap] = useState(null);
  const [directionsResponse, setDirectionsResponse] = useState(null);
  const [origin, setOrigin] = useState('');
  const [destination, setDestination] = useState('');
  const [trainFrom, setTrainFrom] = useState("");
  const [trainTo, setTrainTo] = useState("");
  const [flightFrom, setFlightFrom] = useState("");
  const [flightTo, setFlightTo] = useState("");
  const originAutocompleteRef = useRef(null);
  const destinationAutocompleteRef = useRef(null);
  const [arrivalDate, setArrivalDate] = useState('');
  const [allRoutes, setAllRoutes] = useState([]); // State to store all routes
  const [selectedRoute, setSelectedRoute] = useState(null); // State to store the selected route
  const [expandedRoute, setExpandedRoute] = useState(null);
  const [travelMode, setTravelMode] = useState('BEST'); // State for transit mode
  const [selectedRouteType, setSelectedRouteType] = useState('ROAD'); // Default to 'ROAD'
  //States for travel by trains
  const [fromStation, setFromStation] = useState('');
  const [toStation, setToStation] = useState('');
  const [dateOfJourney, setDateOfJourney] = useState('');
  const [fromStationSuggestions, setFromStationSuggestions] = useState([]);
  const [toStationSuggestions, setToStationSuggestions] = useState([]);
  const [allStations, setAllStations] = useState([]);
  const [showDropdown, setShowDropdown] = useState('');

  //States for travel by flights
  const [fromAirport, setFromAirport] = useState('');
  const [toAirport, setToAirport] = useState('');
  const [fromAirportSuggestions, setFromAirportSuggestions] = useState([]);
  const [toAirportSuggestions, setToAirportSuggestions] = useState([]);
  const [departureDate, setDepartureDate] = useState('');
  const [returnDate, setReturnDate] = useState('');
  const [numAdults, setNumAdults] = useState(1);
  const [cabinClass, setCabinClass] = useState('ECONOMY');
  const [sortFlight, setSortFlight] = useState('BEST');
  const [allAirports, setAllAirports] = useState([]);

  // States related to hotel search
  const [input, setInput] = useState('');
  const [result, setResult] = useState([]);
  const [hotels, setHotels] = useState([]);
  const [loading, setLoading] = useState(false); // Loading state for hotel search
  const [flag, setFlag] = useState(false); // Flag for showing/hiding autocomplete dropdown
  const [checkinDate, setCheckinDate] = useState('');
  const [checkoutDate, setCheckoutDate] = useState('');
  const [adults, setAdults] = useState(1);
  const [children, setChildren] = useState(0);
  const [rooms, setRooms] = useState(1);
  const [coordinates, setCoordinates] = useState({ lat: null, lng: null }); // Coordinates for location
  const [sortBy, setSortBy] = useState('');

  // Effect to fetch request details based on requestId from URL
  useEffect(() => {
    if (requestId) {
      fetchRequestDetails();
    }
  }, [requestId, token]);

  useEffect(() => {
  const handleClickOutside = (e) => {
    if (!e.target.closest('.map-options-popup') && !e.target.closest('.map-options-button')) {
      setShowMapOptions(false);
    }
  };
  document.addEventListener('click', handleClickOutside);
  return () => document.removeEventListener('click', handleClickOutside);
}, []);

  useEffect(() => {
    const fetchStations = async () => {
      try {
        const allFromStations = await searchStation(fromStation);
        setFromStationSuggestions(allFromStations);
      } catch (error) {
        console.error('Error fetching stations:', error);
      }
    };

    if (fromStation) {
      fetchStations();
    }
  }, [fromStation]);

  useEffect(() => {
    const fetchStations = async () => {
      try {
        const alltoStations = await searchStation(toStation);
        setToStationSuggestions(alltoStations);
      } catch (error) {
        console.error('Error fetching stations:', error);
      }
    };

    if (toStation) {
      fetchStations();
    }
  }, [toStation]);

  useEffect(() => {
    const fetchAirports = async () => {
      try {
        const allFromAirports = await searchAirport(fromAirport);
        setFromAirportSuggestions(allFromAirports);
      } catch (error) {
        console.error('Error fetching stations:', error);
      }
    };

    if (fromAirport) {
      fetchAirports();
    }
  }, [fromAirport]);

  useEffect(() => {
    const fetchAirports = async () => {
      try {
        const allToAirports = await searchAirport(toAirport);
        setToAirportSuggestions(allToAirports);
      } catch (error) {
        console.error('Error fetching stations:', error);
      }
    };

    if (toAirport) {
      fetchAirports();
    }
  }, [toAirport]);

  // Function to fetch request details based on requestId
  async function fetchRequestDetails() {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/requests/${requestId}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`Network response was not ok: ${response.status} - ${errorText}`);
      }

      const requestData = await response.json();
      if (requestData.supportNeeded === 'Travel') {
        setOrigin(requestData.source || '');
        setDestination(requestData.destination);
        setArrivalDate(formatDate(requestData.fromDate));
      } else if (requestData.supportNeeded === 'Accommodation') {
        setInput(requestData.destination);
        setCheckinDate(requestData.fromDate.split('T')[0]);
        setCheckoutDate(requestData.toDate.split('T')[0]);
      } else if (requestData.supportNeeded === 'Travel + Accommodation') {
        setOrigin(requestData.source || '');
        setDestination(requestData.destination);
        setArrivalDate(formatDate(requestData.fromDate));
        setInput(requestData.destination);
        setCheckinDate(requestData.fromDate.split('T')[0]);
        setCheckoutDate(requestData.toDate.split('T')[0]);
      }
      // Fetch predictions for autocomplete based on destination
      const url = `${process.env.REACT_APP_OLA_API_URL}/autocomplete?input=${requestData.destination}&api_key=${process.env.REACT_APP_OLA_API_KEY}`;

      try {
        const response = await fetch(url, {
          method: 'GET',
          headers: {
              'Authorization': `Bearer ${process.env.REACT_APP_OLA_API_KEY}` // Ensure proper authorization header if needed
          }
        });
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const data = await response.json();
        setResult(data.predictions);
      } catch (error) {
        console.error('Error fetching predictions:', error);
      }
      
    } catch (error) {
      if (error.response && error.response.data.error === 'Token expired') {
        // Redirect to login page if token is expired
        navigate('/login');
      } else {
          // Handle other errors
          console.error('Error fetching request details:', error);
      }
    }
  }

  // Loading indicator while Google Maps is loading
  if (!isLoaded) {
    return <div>Loading...</div>;
  }

  const handleSelectFromStation = (station) => {
    setFromStation(`${station.properties.code}~${station.properties.name}`);
    setFromStationSuggestions([]);
    setShowDropdown('');
  };

  const handleSelectToStation = (station) => {
    setToStation(`${station.properties.code}~${station.properties.name}`);
    setToStationSuggestions([]);
    setShowDropdown('');
  };

  const handleSelectFromAirport = (station) => {
    setFromAirport(`${station.IATA_code}~${station.city_name}`);
    setFromAirportSuggestions([]);
    setShowDropdown('');
  };

  const handleSelectToAirport = (station) => {
    setToAirport(`${station.IATA_code}~${station.city_name}`);
    setToAirportSuggestions([]);
    setShowDropdown('');
  };

  async function getNearestStation(searchTerm) {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/api/places?query=${encodeURIComponent(searchTerm)}`
    );

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const result = await response.json();
    if (!result || result.length === 0) {
      console.warn("No nearby bus stop found. Using origin instead.");
      return searchTerm; 
    }

    return result[0].formatted_address;
  } catch (error) {
    console.error("Fetch error:", error.message);
    return searchTerm; 
  }
}

  
  //Function to calculate all Routes
  async function getRoute(origin, destination, travelMode){
  if (!origin || !destination) {
    notifyError("Origin or Destination missing", "bottom-center");
    return;
  }

  const directionsService = new window.google.maps.DirectionsService();
  try {
    const results = await directionsService.route({
      origin: String(origin),       
      destination: String(destination),
      travelMode,
      provideRouteAlternatives: true,
      transitOptions: {
        modes: ['RAIL', 'BUS'],
        arrivalTime: new Date(arrivalDate),
      },
    });

  
      if (results.status === 'ZERO_RESULTS') {
        notifyError(NotifyMessages.noRoutesFound, 'bottom-center');
        return;
      }
      results.routes.sort((a, b) => {
        // Assuming each route has only one leg
        const durationA = a.legs[0].duration.value;
        const durationB = b.legs[0].duration.value;
        return durationA - durationB;
      });
      return results;
    } catch (error) {
      // Handle errors from the Directions API
      console.error('Error fetching directions:', error);
    }
  }
  // Function to calculate route using Directions API
  async function calculateRoute(event) {
    event.preventDefault();

    setMapLoading(true);
  
    try {
      if(selectedRouteType === 'FLIGHT') {
        let nearBy = await getFlightRoutes(`${fromAirport.split('~')[0]}.AIRPORT`, `${toAirport.split('~')[0]}.AIRPORT`, departureDate, returnDate, numAdults, cabinClass, sortFlight);
        setAllAirports(nearBy);
      }
      else if(selectedRouteType === 'TRAIN') {
        let nearBy = await getTrainRoutes(fromStation.split('~')[0], toStation.split('~')[0], dateOfJourney);
        setAllStations(nearBy);
      }
      else if (selectedRouteType === 'ROAD' && travelMode === 'BEST') {
        const nearBy = await getNearestStation(`bus stand in ${origin}`);
        const carRoutes = await getRoute(origin, destination, 'DRIVING');
        const busRoutes = await getRoute(nearBy, destination, 'TRANSIT');
        const bikeRoutes = await getRoute(origin, destination, 'TWO_WHEELER');
        let validRoutes = [];
        if (carRoutes && carRoutes.routes && carRoutes.routes.length > 0) {
          validRoutes.push({ ...carRoutes.routes[0], travelMode: 'Car' });
        }
        if (busRoutes && busRoutes.routes && busRoutes.routes.length > 0) {
          validRoutes.push({ ...busRoutes.routes[0], travelMode: 'Bus' });
        }
        if (bikeRoutes && bikeRoutes.routes && bikeRoutes.routes.length > 0) {
          validRoutes.push({ ...bikeRoutes.routes[0], travelMode: 'Bike' });
        }
        setAllRoutes(validRoutes);
        setDirectionsResponse(carRoutes);
      } else if (selectedRouteType === 'ROAD' && travelMode === 'TRANSIT') {
        const nearBy = await getNearestStation(`bus stand in ${origin}`);
        const results = await getRoute(nearBy, destination, travelMode);
        const updatedRoutes = results && results.routes.map((route) => ({
          ...route,
          travelMode: 'Bus',
        }));
        setAllRoutes(updatedRoutes);
        setDirectionsResponse(results);
      } else if(selectedRouteType === 'ROAD' && (travelMode !== 'TRANSIT' || travelMode !== 'BEST')){
        const results = await getRoute(origin, destination, travelMode);
        const updatedRoutes = results.routes.map((route) => ({
          ...route,
          travelMode: travelMode === 'DRIVING' ? 'Car' : travelMode === 'WALKING' ? 'Walk' : 'Bike',
        }));
        setAllRoutes(updatedRoutes);
        setDirectionsResponse(results);
      }
    } catch (error) {
      console.error('Error calculating route:', error);
      notifyError('An error occurred while calculating the route. Please try again.', 'bottom-center');
    } finally {
      setMapLoading(false); // Ensure loading state is reset
    }
  }
  
  // Function to handle route card selection
  const handleRouteSelection = (selectedRoute) => {
    setSelectedRoute(selectedRoute); // Store the selected route
    setExpandedRoute(expandedRoute === selectedRoute ? null : selectedRoute);  // Toggle details visibility
    setDirectionsResponse(prev => ({
      ...prev,
      routes: [selectedRoute] // Set the directions response to only include the selected route
    }));
  };

  // Function to clear current route and reset states
  function clearRoute() {
    //clear road states
    if(selectedRouteType==='ROAD'){
      setDirectionsResponse(null);
      setAllRoutes(null);
      setOrigin('');
      setDestination('');
    }
    //clear flight states
    else if(selectedRouteType==='FLIGHT'){
      setFromAirport('');
      setToAirport('');
      setFromAirportSuggestions([]);
      setToAirportSuggestions([]);
      setDepartureDate('');
      setReturnDate('');
      setNumAdults(1);
      setCabinClass('ECONOMY');
      setSortFlight('BEST');
      setAllAirports([]);
    }
    //clear train states
    else if(selectedRouteType==='TRAIN'){
      setFromStation('');
      setToStation('');
      setDateOfJourney('');
      setFromStationSuggestions([]);
      setToStationSuggestions([]);
      setAllStations([]);
      setShowDropdown('');
    }
  }

  // Function to handle input change for autocomplete
  const handleInput = async (val) => {
    setInput(val);
    setFlag(true);

    const url = `${process.env.REACT_APP_OLA_API_URL}/autocomplete?input=${val}&api_key=${process.env.REACT_APP_OLA_API_KEY}`;

    try {
      const response = await fetch(url, {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${process.env.REACT_APP_OLA_API_KEY}` // Ensure proper authorization header if needed
        }
      });
      const data = await response.json();
      setResult(data.predictions);
    } catch (error) {
      console.error('Error fetching predictions:', error);
    }
  };

  // Function to handle selection of a prediction from autocomplete
  const handlePrediction = async (prediction) => {
    setInput(prediction.description);
    setResult([]);
    setFlag(false);

    // Fetch place details based on place_id
    const url = `${process.env.REACT_APP_OLA_API_URL}/details?place_id=${prediction.place_id}&api_key=${process.env.REACT_APP_OLA_API_KEY}`;

    try {
      const response = await fetch(url, {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${process.env.REACT_APP_OLA_API_KEY}` // Ensure proper authorization header if needed
        }
      });
      const data = await response.json();

      // Use the retrieved data to set coordinates
      if (data.result.geometry && data.result.geometry.location) {
        const { lat, lng } = data.result.geometry.location;
        setCoordinates({ lat, lng });
      }
    } catch (error) {
      notifyError(NotifyMessages.selectLocation, 'bottom-center');
      console.error('Error fetching place details:', error);
      return;
    }
  };

  // Function to search hotels based on coordinates and other parameters
  const searchHotelsByCoordinates = async (latitude, longitude) => {
    const today = moment().startOf('day');
    if (!checkinDate || !checkoutDate || moment(checkinDate).isBefore(today, 'day')) {
      notifyError(NotifyMessages.checkinValidation, 'bottom-center');
      return;
    }
    if (adults < 1 || rooms < 1) {
      notifyError(NotifyMessages.adultValidation, 'bottom-center');
      return;
    }
    if (adults < rooms) {
      notifyError(NotifyMessages.roomValidation, 'bottom-center');
      return;
    }
    if (!latitude || !longitude) {
      if (result.length > 0) {
        await handlePrediction(result[0]);
      } else {
        notifyError(NotifyMessages.selectLocation, 'bottom-center');
        return;
      }
    }
    if (!sortBy) {
      notifyError(NotifyMessages.sortBySelection, 'bottom-center');
      return;
    }

    setLoading(true);
    const hotelSearchUrl = process.env.REACT_APP_HOTEL_URL;
    const params = {
      include_adjacency: 'true',
      order_by: sortBy,
      longitude: longitude,
      latitude: latitude,
      room_number: rooms,
      adults_number: adults,
      locale: 'en-gb',
      checkin_date: checkinDate,
      checkout_date: checkoutDate,
      page_number: 0,
      filter_by_currency: 'INR',
      units: 'metric'
    };
    const queryString = new URLSearchParams(params).toString();
    const url = `${hotelSearchUrl}?${queryString}`;

    const options = {
      method: 'GET',
      headers: {
        'x-rapidapi-key': process.env.REACT_APP_BOOKING_API_KEY,
        'x-rapidapi-host': process.env.REACT_APP_BOOKING_API_HOST
      }
    };

    try {
      const response = await fetch(url, options);
      const data = await response.json();
      setHotels(data.result);
    } catch (error) {
      console.error('Error fetching hotels:', error);
    } finally {
      setLoading(false); // End loading state
    }
  };

  // Function to generate a dynamic URL for booking a hotel
  const generateHotelUrl = (hotel) => {
  // Encode hotel name and city to prevent URL issues
  const query = encodeURIComponent(`${hotel.hotel_name}, ${hotel.city_name || hotel.city}`);

  // Add user’s selected dates
  const params = new URLSearchParams({
    ss: query,  // hotel name + city
    checkin: checkinDate,
    checkout: checkoutDate,
    group_adults: adults,
    no_rooms: rooms,
    group_children: children,
    aid: 304142,
    label: 'gen173rf-1FCAsobEIbdDEwLWhvdGVscy1wcml2YXRlLWxpbWl0ZWVkSDNYA2hsiAEBmAExuAEXyAEM2AEB6AEB-AECiAIBogIObG9jYWxob3N0OjMwMDCoAgO4Avf_k7QGwAIB0gIkMzUyNzVlNTAtZWJlNy00YTEyLWFlYTgtY2FkYTE5MGMwOWJl2AIF4AIB'
  }).toString();

  // Return official Booking.com search URL
  return `https://www.booking.com/searchresults.html?${params}`;
};



  function handleOriginPlaceChanged() {
    const place = originAutocompleteRef.current?.getPlace()
    if (place?.formatted_address) {
      setOrigin(place.formatted_address)
    }
  }

  function handleDestinationPlaceChanged() {
    const place = destinationAutocompleteRef.current?.getPlace()
    if (place?.formatted_address) {
      setDestination(place.formatted_address)
    }
  }
  
  // Data for tabs to switch between Travel and Hotel views
  const tabData = [
    { label: "Travel" },
    { label: "Hotel" },
  ];

  return (
    <div className="container">
      <Header /> {/* Header component */}
      <ToastContainer /> {/* Error notification component */}
   <div id="map" style={{ position: 'relative' }}>
  {/* Google Map */}
  <GoogleMap
    center={center}
    zoom={15}
    mapContainerStyle={{ width: '100%', height: '100%' }}
    options={{
      mapTypeId: mapType,
      zoomControl: false,
      streetViewControl: false,
      mapTypeControl: false,
      fullscreenControl: false,
    }}
    onLoad={map => setMap(map)}
  >
    {directionsResponse && <DirectionsRenderer directions={directionsResponse} />}
  </GoogleMap>

  {/* Map Options Button - stays on top */}
  <div
    className="map-options-button"
    onClick={() => setShowMapOptions(!showMapOptions)}
  >
    <img src={layerIcon} alt="Map Options" className="map-layer-icon" />
  </div>

  {/* Popup - appears only when toggled */}
  {showMapOptions && (
    <div className="map-options-popup">
      <h4>Map Type</h4>
      <div className="map-types">
        <button onClick={() => setMapType('roadmap')}>Default</button>
        <button onClick={() => setMapType('satellite')}>Satellite</button>
        <button onClick={() => setMapType('terrain')}>Terrain</button>
      </div>
    </div>
  )}
</div>


      <Tabs tabs={tabData} defaultTab={requestId && !origin ? 1 : 0}>
        <div className="controls">
          <form onSubmit={calculateRoute}>
          <div className="radio-buttons">
            <label>
              <input
                type="radio"
                value="ROAD"
                checked={selectedRouteType === 'ROAD'}
                onChange={() => setSelectedRouteType('ROAD')}
              />
              By Road
            </label>
            <label>
              <input
                type="radio"
                value="TRAIN"
                checked={selectedRouteType === 'TRAIN'}
                onChange={() => setSelectedRouteType('TRAIN')}
              />
              By Train
            </label>
            <label>
              <input
                type="radio"
                value="FLIGHT"
                checked={selectedRouteType === 'FLIGHT'}
                onChange={() => setSelectedRouteType('FLIGHT')}
              />
              By Flight
            </label>
          </div>
          <div className={`input-group`}>
            {selectedRouteType === 'ROAD' && (
              <>
                <label htmlFor='origin'><b>Origin:</b>
                  <Autocomplete
                    onLoad={autocomplete => (originAutocompleteRef.current = autocomplete)}
                    onPlaceChanged={handleOriginPlaceChanged}
                  >
                    <input
                      type="text"
                      id="origin"
                      placeholder="Starting"
                      value={origin}
                      onChange={(e) => setOrigin(e.target.value)}
                      required
                    />
                  </Autocomplete>
                </label>
               <button
  type="button"
  className="reverse-button"
  onClick={() => {
    const temp = origin;
    setOrigin(destination);
    setDestination(temp);
  }}
>
  <MdSwapHoriz size={22} />
</button>


                {/* Autocomplete for Destination */}
                <label htmlFor='destination'><b>Destination:</b>
                  <Autocomplete
                    onLoad={autocomplete => (destinationAutocompleteRef.current = autocomplete)}
                    onPlaceChanged={handleDestinationPlaceChanged}
                  >
                    <input
                      type="text"
                      id="destination"
                      placeholder="Ending"
                      value={destination}
                      onChange={(e) => setDestination(e.target.value)}
                      required
                    />
                  </Autocomplete>
                </label>


                <label htmlFor="travelMode"><b>Travel Mode:</b>
                  <select
                    id="travelMode"
                    value={travelMode}
                    onChange={(e) => setTravelMode(e.target.value)}
                  >
                      <option value="BEST">Best Routes</option>
                      <option value="DRIVING">Car</option>
                      <option value="TRANSIT">Bus</option>
                      <option value="TWO_WHEELER">Bike</option>
                      <option value="WALKING">Walk</option>
                    </select>
                </label>
                {/* Input for Departure Time */}
                <label htmlFor="arrivalDate"><b>Arrival Time:</b>
                  <input
                    type="datetime-local"
                    min={formatDate(new Date())}
                    id="arrivalDate"
                    value={arrivalDate}
                    onChange={(e) => setArrivalDate(e.target.value)}
                  />
                </label>
              </>
            )}

            {selectedRouteType === 'TRAIN' && (
              <>
                <label htmlFor="fromStation"><b>From Station:</b>
                  <input
                    type="text"
                    id="fromStation"
                    placeholder="Starting Station"
                    value={fromStation}
                    onChange={(e) => {
                      setFromStation(e.target.value); 
                      setShowDropdown('fromStations'); 
                    }}
                    required
                  />
                  {showDropdown === 'fromStations' && (
                    <div className='suggestions-dropdown'>
                      <ul className="predictions-dropdown">
                        {fromStationSuggestions.length > 0 ? (
                          fromStationSuggestions.map((station, index) => (
                            <li key={index} onClick={() => handleSelectFromStation(station)}>
                              {station.properties.name} - {station.properties.code}
                            </li>
                          ))
                        ) 
                        : (
                          <li className='no-results'>No results found</li>
                        )}
                      </ul>
                      </div>
                    )}
                </label>
    <button
  type="button"
  className="reverse-button"
  onClick={() => {
    const temp = fromStation;
    setFromStation(toStation);
    setToStation(temp);
  }}
>
  <MdSwapHoriz size={20} />
</button>
                <label htmlFor="toStation"><b>To Station:</b>
                  <input
                    type="text"
                    id="toStation"
                    placeholder="Ending Station"
                    value={toStation}
                    onChange={(e) => {
                      setToStation(e.target.value); 
                      setShowDropdown('toStations');
                    }}
                    required
                  />
                  {showDropdown === 'toStations' && (
                    <div className='suggestions-dropdown'>
                      <ul className="predictions-dropdown">
                        {toStationSuggestions.length > 0 ? (
                          toStationSuggestions.map((station, index) => (
                            <li key={index} onClick={() => handleSelectToStation(station)}>
                              {station.properties.name} - {station.properties.code}
                            </li>
                          ))
                        ) 
                        : (
                          <li className='no-results'>No results found</li>
                        )}
                      </ul>
                      </div>
                    )}
                </label>
                <label htmlFor="dateOfJourney"><b>Date of Journey:</b>
                  <input
                    type="date"
                    id="dateOfJourney"
                    value={dateOfJourney}
                    onChange={(e) => setDateOfJourney(e.target.value)}
                    required
                  />
                </label>
              </>
            )}

            {selectedRouteType === 'FLIGHT' && (
              <div className='flight'>
                <div className='flight-row'>
                  <label htmlFor="fromAirport"><b>From Airport:</b>
                    <input
                      type="text"
                      id="fromAirport"
                      placeholder="Starting Airport"
                      value={fromAirport}
                      onChange={(e) => {
                        setFromAirport(e.target.value);
                        setShowDropdown('fromAirports'); 
                      }}
                      required
                    />
                    {showDropdown === 'fromAirports' && (
                      <div className='suggestions-dropdown'>
                        <ul className="predictions-dropdown">
                          {fromAirportSuggestions.length > 0 ? (
                            fromAirportSuggestions.map((station, index) => (
                              <li key={index} onClick={() => handleSelectFromAirport(station)}>
                                {station.airport_name} - {station.IATA_code}
                              </li>
                            ))
                          ) 
                          : (
                            <li className='no-results'>No results found</li>
                          )}
                        </ul>
                        </div>
                      )}
                  </label>
                <button
  type="button"
  className="reverse-button"
  onClick={() => {
    const temp = fromAirport;
    setFromAirport(toAirport);
    setToAirport(temp);
  }}
>
  <MdSwapHoriz size={20} />
</button>


                  <label htmlFor="toAirport"><b>To Airport:</b>
                    <input
                      type="text"
                      id="toAirport"
                      placeholder="Ending Airport"
                      value={toAirport}
                      onChange={(e) => {
                        setToAirport(e.target.value);
                        setShowDropdown('toAirports');
                      }}
                      required
                    />
                    {showDropdown === 'toAirports' && (
                      <div className='suggestions-dropdown'>
                        <ul className="predictions-dropdown">
                          {toAirportSuggestions.length > 0 ? (
                            toAirportSuggestions.map((station, index) => (
                              <li key={index} onClick={() => handleSelectToAirport(station)}>
                                {station.airport_name} - {station.IATA_code}
                              </li>
                            ))
                          ) 
                          : (
                            <li className='no-results'>No results found</li>
                          )}
                        </ul>
                        </div>
                      )}
                  </label>
                  <label htmlFor="sortFlight"><b>Sort By:</b>
                    <select
                      id="sortFlight"
                      value={sortFlight}
                      onChange={(e) => setSortFlight(e.target.value)}
                    >
                      <option value="BEST">Best</option>
                      <option value="CHEAPEST">Cheapest</option>
                      <option value="FASTEST">Fastest</option>
                    </select>
                  </label>
                </div>
                <div className='flight-row-2'>
                <label htmlFor="departureDate"><b>Departure Date:</b>
                    <input
                      type="date"
                      id="departureDate"
                      value={departureDate}
                      onChange={(e) => setDepartureDate(e.target.value)}
                      required
                    />
                  </label>
                  <label htmlFor="returnDate"><b>Return Date:</b>
                    <input
                      type="date"
                      id="returnDate"
                      value={returnDate}
                      onChange={(e) => setReturnDate(e.target.value)}
                    />
                  </label>
                  <label htmlFor="numAdults"><b>Adults:</b>
                    <input
                      type="number"
                      id="numAdults"
                      value={numAdults}
                      onChange={(e) => setNumAdults(e.target.value)}
                      min="1"
                    />
                  </label>
                  <label htmlFor="cabinClass"><b>Cabin Class:</b>
                    <select
                      id="cabinClass"
                      value={cabinClass}
                      onChange={(e) => setCabinClass(e.target.value)}
                    >
                      <option value="ECONOMY">Economy</option>
                      <option value="PREMIUM_ECONOMY">Premium Economy</option>
                      <option value="BUSINESS">Business</option>
                      <option value="FIRST">First</option>
                    </select>
                  </label>
                </div>
              </div>
            )}
          </div>
          <div className="info">
            <span>
              <button type="submit" className='route-buttons'>Get Route</button>
              <button type="button" onClick={clearRoute} className='clear-button'>
                <FaDeleteLeft style={{marginRight:'3px'}}/>
                Clear
              </button>
            </span>
            {selectedRouteType=== 'ROAD' &&
            <button
              className="icon-button"
              onClick={() => {
                map.panTo(center);
                map.setZoom(5);
              }}
            >
              <FaLocationArrow />
            </button>}
          </div>
          </form>
          {/* New section for displaying all routes */}
          <div className="route-list">
          <h3>Route Details:</h3>
          {mapLoading ? (
                <p>Loading routes...</p>) : (
                  <>
                    {(() => {
                      switch (selectedRouteType) {
                        case 'ROAD':
                          return (
                            allRoutes && allRoutes.length > 0 ? (
                              <ul>
                                {allRoutes.map((route, index) => (
                                  <li 
                                    key={index}  
                                    className={`route-card ${selectedRoute === route ? 'selected' : ''}`}  
                                    onClick={() => handleRouteSelection(route)}
                                  >
                                    <h3>Via {route.travelMode}</h3>
                                    {route.travelMode === 'Bus' && <>
                                      <p>{route.legs[0].departure_time.text} ({moment(route.legs[0].departure_time.value).format('DD-MM-YYYY')}) to </p>
                                      <p>{route.legs[0].arrival_time.text} ({moment(route.legs[0].arrival_time.value).format('DD-MM-YYYY')})</p>
                                    </>}
                                    <p><b>Distance:</b> {route.legs[0].distance.text}</p>
                                    <p><b>Duration:</b> {route.legs[0].duration.text}</p>
                                    <div>
                                      {route.travelMode === 'Bus' && route.legs[0].steps.map((e, i) => (
                                        e.transit ? (
                                          <p key={i} className='travels-name'>{e.transit.line.agencies[0].name}</p>
                                        ) : null
                                      ))}
                                    </div>
                                    <button className='show-steps' onClick={() => handleRouteSelection(route)}>
                                      {expandedRoute === route ? 'Hide Details' : 'Show Details'}
                                    </button>
                                    {expandedRoute === route && (
                                      <div className="route-steps">
                                        <h4>{route.legs[0].start_address}</h4>
                                        {route.legs[0].steps.map((step, i) => (
                                          <div key={i} className="each-step">
                                            <p>step {i+1}</p>
                                            <p></p>
                                            <div
                                              dangerouslySetInnerHTML={{ __html: step.instructions }}
                                            />
                                            <p><b>Distance:</b> {step.distance.text}</p>
                                            <p><b>Duration:</b> {step.duration.text}</p>
                                            {step.transit && 
                                            <div>
                                              <p className='travels-name'>{step.transit.line && step.transit.line.agencies[0].name}</p>
                                              <p>{step.transit.headsign && step.transit.headsign}</p>
                                              <p>{step.transit.departure_time.text}-Depart {step.transit.departure_stop.name}</p>
                                              <p>{step.transit.arrival_time.text}-Arrive {step.transit.arrival_stop.name}</p>
                                              <p><a href={step.transit.line.agencies[0].url} target="_blank" rel="noopener noreferrer">Book now</a></p>
                                            </div>}
                                          </div>
                                        ))}
                                        <h4>{route.legs[0].end_address}</h4>
                                      </div>
                                    )}
                                  </li>
                                ))}
                              </ul>
                            ) : (
                              <p>No routes available</p>
                            )
                          );
              
                        case 'TRAIN':
                          return (
                            allStations && allStations.length > 0 ? (
                              <ul>
                                {allStations.map((station, index) => (
                                  <li 
                                    key={index}  
                                    className={`route-card ${selectedRoute === station ? 'selected' : ''}`}  
                                  >
                                    <h3>{station.from_station_name} ({station.from}) to {station.to_station_name} ({station.to})</h3>
                                    <p key={index} className='travels-name train'>{station.train_name}</p>
                                    <p><b>Train Number:</b> {station.train_number}</p>
                                    <p><b>Departure Time:</b> {moment(station.from_std, "HH:mm").format("hh:mm A")} on {station.train_date}</p>
                                    <p><b>Arrival Time:</b> {moment(station.to_std, "HH:mm").format("hh:mm A")} on {station.train_date}</p>
                                    <p><b>Total Distance:</b> {station.distance} km</p>
                                    <p><b>Travel Duration:</b> {`${parseInt(station.duration.split(':')[0])}h ${parseInt(station.duration.split(':')[1])}m`}</p>
                                    <p><b>Class Available:</b> {station.class_type.join(', ')}</p>
                                    <p><b>Run Days:</b> {station.run_days.join(', ')}</p>
                                    {station.has_pantry && <p><b>Pantry Available:</b> Yes</p>}
                                    <p>
                                      <a href={`https://www.makemytrip.com/railways/listing?classCode=&className=All%20Classes&date=${station.train_date.split('-').reverse().join('')}&destStn=${station.to}&srcStn=${station.from}`} target="_blank" rel="noopener noreferrer">
                                        Book now
                                      </a></p>
                                  </li>
                                ))}
                              </ul>
                            ) : (
                              <p>No trains available</p>
                            )
                          );
              
                        case 'FLIGHT':
                          return (
                            allAirports && allAirports.length > 0 ? (
                              <ul>
                                {allAirports.map((route, index) => (
                                  <li 
                                    key={index}
                                    className={`route-card ${route.selected ? 'selected' : ''}`}  
                                  >
                                    <h3>{`${fromAirport} to ${toAirport}`}</h3>
                                    { _.uniqBy(
                                      route.segments.flatMap(segment =>
                                        segment.legs.flatMap(leg => leg.carriersData)
                                      ),
                                      'name'
                                      ).map((carrier, index) => (
                                      <p key={index} className='travels-name flight'>{carrier.name}</p>
                                    ))}                                                                           
                                    {route.tripType === 'ROUNDTRIP' && <h3 className='flight-heading'>Starting Flight <FaArrowTurnDown className='flight-icon'/></h3>}
                                    <p><b>Departure Airport:</b> {route.segments[0].departureAirport.name} ({route.segments[0].departureAirport.code})</p>
                                    <p><b>Arrival Airport:</b> {route.segments[0].arrivalAirport.name} ({route.segments[0].arrivalAirport.code})</p>
                                    <p><b>Departure Time:</b> {`${moment(route.segments[0].departureTime).format('hh:mm A [on] DD-MM-YYYY')}`}</p>
                                    <p><b>Arrival Time:</b> {`${moment(route.segments[0].arrivalTime).format('hh:mm A [on] DD-MM-YYYY')}`}</p>
                                    <p><b>Travel Duration:</b> {`${Math.floor(moment.duration(route.segments[0].totalTime, 'seconds').asHours())}h ${moment.duration(route.segments[0].totalTime, 'seconds').minutes()}m`}</p>
                                    {route.tripType === 'ROUNDTRIP' && (
                                      <>
                                        <h3 className='flight-heading'>Returning Flight <FaArrowTurnDown className='flight-icon'/></h3>
                                        <p><b>Departure Airport:</b> {route.segments[1].departureAirport.name} ({route.segments[1].departureAirport.code})</p>
                                        <p><b>Arrival Airport:</b> {route.segments[1].arrivalAirport.name} ({route.segments[1].arrivalAirport.code})</p>
                                        <p><b>Departure Time:</b> {`${moment(route.segments[1].departureTime).format('hh:mm A [on] DD-MM-YYYY')}`}</p>
                                        <p><b>Arrival Time:</b> {`${moment(route.segments[1].arrivalTime).format('hh:mm A [on] DD-MM-YYYY')}`}</p>
                                        <p><b>Travel Duration:</b> {`${Math.floor(moment.duration(route.segments[1].totalTime, 'seconds').asHours())}h ${moment.duration(route.segments[1].totalTime, 'seconds').minutes()}m`}</p>
                                      </>
                                    )}
                                    {/* <p><b>Total Price:</b> {`Rs. ${route.priceBreakdown.total.units}`}</p> */}
                                    <p><b>Trip Type:</b> {route.tripType}</p>
                                    <p>
                                      <a href={`https://flights.booking.com/flights/${fromAirport.split('~')[0]}.AIRPORT-${toAirport.split('~')[0]}.AIRPORT/?type=${route.tripType}&adults=${numAdults}&cabinClass=${cabinClass}&children=&from=${fromAirport.split('~')[1]}.AIRPORT&to=${toAirport.split('~')[1]}.AIRPORT&fromCountry=IN&toCountry=IN&depart=${departureDate}&return=${returnDate}&sort=${sortFlight}`} target="_blank" rel="noopener noreferrer">
                                        Book via Booking.com
                                      </a>
                                    </p>
                                    <p>
                                      <a href={`https://www.ixigo.com/search/result/flight?from=${fromAirport.split('~')[0]}&to=${toAirport.split('~')[0]}&date=${departureDate.split('-').reverse().join('')}&returnDate=${returnDate.split('-').reverse().join('')}&adults=${numAdults}&children=0&infants=0&class=e&source=Search&sort_type=best`} target="_blank" rel="noopener noreferrer">
                                        Book via Ixigo.com
                                      </a>
                                    </p>
                                </li>
                                ))}
                              </ul>
                            ) : (
                              <p>No flights available</p>
                            )
                          );
              
                        default:
                          return <p>Please select a valid route type</p>;
                      }
                    })()}
                  </>
                )}
        </div>

        </div>
        {/* Controls for Hotel search */}
        <div className='controls'>
          <div className='hotel-container'>
            <div className='row'>
              <div className='input-group'>
                {/* Input for entering location */}
                <label htmlFor='location'><b>Location:</b>
                  <input
                    type='text'
                    id='location'
                    placeholder='Enter Location'
                    value={input}
                    onChange={(e) => {
                      handleInput(e.target.value);
                    }}
                    required
                  />
                </label>
                {/* Dropdown for autocomplete predictions */}
                {flag && (
                  <div className='dropdown-container'>
                    <ul className='predictions-dropdown'>
                      {result.length > 0 ? (
                        result.map((prediction, index) => (
                          <li
                            key={index}
                            onClick={() => handlePrediction(prediction)}
                          >
                            {prediction.description}
                          </li>
                        ))
                      ) : (
                        <li className='no-results'>No results found</li>
                      )}
                    </ul>
                  </div>
                )}
                {/* Input for Check-in date */}
                <label htmlFor='checkindate'><b>Checkin-date:</b>
                  <input
                    type='date'
                    id='checkindate'
                    placeholder='Check-in date'
                    value={checkinDate}
                    onChange={(e) => setCheckinDate(e.target.value)}
                    required
                  />
                </label>
                {/* Input for Check-out date */}
                <label htmlFor='checkoutdate'><b>Checkout-date:</b>
                  <input
                    type='date'
                    id='checkoutdate'
                    placeholder='Check-out date'
                    value={checkoutDate}
                    onChange={(e) => setCheckoutDate(e.target.value)}
                    required
                  />
                </label>
              </div>
            </div>
            <div className='row'>
              <div className='input-group new'>
                {/* Input for number of Adults */}
                <label htmlFor='adults'><b>Adults:</b>
                  <input
                    className='numberof'
                    type='number'
                    id='adults'
                    placeholder='No. of adults'
                    value={adults}
                    onChange={(e) => setAdults(parseInt(e.target.value))}
                  />
                </label>
                {/* Input for number of Rooms */}
                <label htmlFor='rooms'><b>Rooms:</b>
                  <input
                    className='numberof'
                    type='number'
                    id='rooms'
                    placeholder='No.of rooms'
                    value={rooms}
                    onChange={(e) => setRooms(parseInt(e.target.value))}
                  />
                </label>
                <label htmlFor="sortBy"><b>Sort By:</b>
                    <select
                      id="sortBy"
                      value={sortBy}
                      onChange={(e) => setSortBy(e.target.value)}
                      required
                    >
                        <option value="">--Select one--</option>
                        <option value="price">Price</option>
                        <option value="popularity">Popularity</option>
                        <option value="distance">Distance</option>
                        <option value="review_score">Customer Rating</option>
                      </select>
                  </label>
                {/* Button to search for Hotels */}
                <button
                  className='search-button'
                  onClick={() => {
                    searchHotelsByCoordinates(coordinates.lat, coordinates.lng);
                  }}
                >
                  Search Hotels
                </button>
              </div>
            </div>
            <div className='hotel-info'>
              {/* Displaying hotel information */}
              {loading ? (
                <p>Loading hotels...</p>
              ) : hotels && hotels.length > 0 ? (
                <div className='hotel-card'>
                  <h2>Hotels:</h2>
                  <ul>
                    {hotels.filter(hotel => parseFloat(hotel.distance) <= 25).map((hotel, index) => (
                      <li key={index}>
                        <div class="hotel-name">{hotel.hotel_name}</div>
                        <div class="hotel-address">{hotel.address}{', '}{hotel.city}</div>
                        <div class="hotel-distance">{parseFloat(hotel.distance)}{' kms'}</div>
                        <div class="hotel-distance">Rs.{hotel.price_breakdown.all_inclusive_price}</div>
                        {/* Link to book the hotel */}
                        <a
                          href={generateHotelUrl(hotel)}
                          target='_blank'
                          rel='noopener noreferrer'
                          className='booking-url'
                        >
                          Book now
                        </a>
                      </li>
                    ))}
                  </ul>
                </div>
              ) : (
                <p>No Hotels Found</p>
              )}
            </div>
          </div>
        </div>
      </Tabs>
      <Footer /> {/* Footer component */}
    </div>
  );
}

export default Map;
